<script lang="ts" setup>
import MarriageCostProductLpTemplate from '~/components/templates/ProductLpTemplate/marriageCost/MarriageCostProductLpTemplate.vue';
</script>

<template>
  <MarriageCostProductLpTemplate />
</template>

<style lang="scss" module></style>
